export default {
  getLinks: (state) => state.links,
  getPermissions: (state) => state.permissions,
  getConsumptionReportUrl: (state) => state.consumptionReportUrl,
  getConsumptionReportPagination: (state) => state.consumptionReportPagination,
};
